import { render } from "./VTag.vue?vue&type=template&id=7f1856c0"
import script from "./VTag.vue?vue&type=script&lang=js"
export * from "./VTag.vue?vue&type=script&lang=js"

import "./VTag.vue?vue&type=style&index=0&id=7f1856c0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__